module.exports = __webpack_public_path__ + "static/media/bg11.07f58bf4.jpeg";